// @flow
export default function columnWidth(columns: number) {
  // to fix to 2 decimal places
  return Math.floor((columns / 12) * 10000) / 100;
}
